import { render } from "./pageDetailComponent.vue?vue&type=template&id=3b51999d"
import script from "./pageDetailComponent.vue?vue&type=script&lang=js"
export * from "./pageDetailComponent.vue?vue&type=script&lang=js"

import "./pageDetailComponent.vue?vue&type=style&index=0&id=3b51999d&lang=scss"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentsBusiness/pageDetailComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b51999d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b51999d', __exports__)) {
    api.reload('3b51999d', __exports__)
  }
  
  module.hot.accept("./pageDetailComponent.vue?vue&type=template&id=3b51999d", () => {
    api.rerender('3b51999d', render)
  })

}


export default __exports__